import type { CSSProperties } from 'react';

/**
 * Symbol tiles for the floor — the till's payment methods today.
 *
 * A tile is a big symbol with its word UNDER it, not a word button: the
 * cashier may not read the label, so the symbol carries the meaning and the
 * selected state is shown by border + fill + colour together, never colour
 * alone. Shared here rather than in the route so screens compose it instead
 * of each hand-rolling its own (CLAUDE.md rule 12, gap G31).
 */
export function symbolTileStyle(selected: boolean): CSSProperties {
  return {
    minHeight: '5.5rem',
    padding: 'var(--space-3) var(--space-2)',
    borderRadius: 'var(--radius-md)',
    border: `2px solid ${selected ? 'var(--color-primary)' : 'var(--color-border)'}`,
    background: selected ? 'var(--color-primary-soft)' : 'var(--color-surface)',
    color: selected ? 'var(--color-primary)' : 'var(--color-on-surface)',
    boxShadow: selected ? 'var(--shadow-1)' : 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--space-2)',
    cursor: 'pointer',
    fontFamily: 'inherit',
    minWidth: 0,
  };
}

export const symbolTileLabelStyle: CSSProperties = {
  fontSize: 'var(--text-meta)',
  fontWeight: 650,
  lineHeight: 1.2,
  textAlign: 'center',
  overflowWrap: 'anywhere',
};
